export default __webpack_public_path__ + "static/media/DSC06012.801c7782.jpg";